export default __webpack_public_path__ + "static/media/serpr-geometry-1.268421cd.png";